import { useNavigate, useParams } from "react-router-dom";
import { useTranslation } from "./useTranslation";
import { useTitle } from "./use-title";

export const usePageHelper = (pageTitle: string, isRawTitle = false) => {
  const routeParams = useParams();
  const { t } = useTranslation();
  const navigate = useNavigate();
  useTitle(isRawTitle ? pageTitle : t(pageTitle));

  return {
    t,
    routeParams,
    navigate,
  };
};
